'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';


import Image from 'next/image';
import { useState } from 'react';

import type { HousingPropertyDetail } from '@eliadmin/core/src/api/housing/housing-types';
import { LightboxComponent } from '@eliadmin/core/src/components/lightbox/lightbox-component';
import { useDisclosure } from '@eliadmin/core/src/hooks/use-disclosure';
import { cn } from '@eliadmin/core/src/utils/style-utils';

// Mobile:  2, 1, 2, 1, … (period 3)
// Desktop: 3, 2, 3, 2, … (period 5)
function getColSpan(index: number): string {
  const mobileSpan = index % 3 < 2 ? 'col-span-6' : 'col-span-12';
  const desktopSpan = index % 5 < 3 ? 'sm:col-span-4' : 'sm:col-span-6';
  return `${mobileSpan} ${desktopSpan}`;
}

export function HousingTabGallery({ housing }: { housing: HousingPropertyDetail }) {
  const { isOpen, setIsOpen } = useDisclosure(false);
  const [imagesSorted, setImagesSorted] = useState<{ url: string; name: string }[]>([]);

  const handleOpenGallery = (index: number) => () => {
    const images = housing.images ?? [];
    const sorted = [...images.slice(index), ...images.slice(0, index)];
    setImagesSorted(sorted);
    setIsOpen(true);
  };

  return (
    <>
      <LightboxComponent isOpen={isOpen} setIsOpen={setIsOpen} images={imagesSorted} />
      <div className="grid w-full grid-cols-12 gap-2 sm:gap-3">
        {housing.images?.map((image, index) => (
          <div
            key={image?.name}
            className={cn(
              'relative aspect-video w-full cursor-pointer overflow-hidden rounded-[16px] transition-all hover:opacity-80 sm:rounded-[24px]',
              getColSpan(index),
            )}
            onClick={handleOpenGallery(index)}
          >
            <Image src={image?.url} alt={resolveImageAlt(image, undefined)} fill className="object-cover" />
          </div>
        ))}
      </div>
    </>
  );
}
